import { render, staticRenderFns } from "./checkpageList.vue?vue&type=template&id=00494c1a&scoped=true&"
import script from "./checkpageList.vue?vue&type=script&lang=js&"
export * from "./checkpageList.vue?vue&type=script&lang=js&"
import style0 from "./checkpageList.vue?vue&type=style&index=0&id=00494c1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00494c1a",
  null
  
)

export default component.exports